<template>
  <div class="manage">
    <div v-if="addNew">
      <add-plan-form
        :key="newKey"
        v-bind:features="features"
        v-bind:newPlan="newPlan"
        v-on:update-plan="addPlan"
        v-on:cancel="goToDashboard"
      ></add-plan-form>
    </div>
    <div v-if="openForm && !addNew">
      <add-plan-form
        v-bind:newPlan="newPlan"
        v-bind:features="features"
        v-bind:plan="editablePlan"
        v-on:cancel="closeForm"
        v-on:update-plan="updatePlan"
      ></add-plan-form>
    </div>
    <div style="margin-bottom: 4rem" v-if="!openForm && !addNew">
      <div class="published-plan">
        <div class="published-plan-text">{{ title }}</div>
      </div>
      <div class="row plan-content-wrapper">
        <div
          style="margin-bottom: 3rem !important;"
          class="col-3"
          :key="index"
          v-for="(plan, index) in plans"
        >
          <plan-template
            v-bind:index="index"
            v-bind:plan-obj="plan"
            v-bind:hide-edit="published"
            v-bind:saved="!published"
            v-on:edit-plan="editPlan(plan)"
            v-on:publish-plan="updatePlan"
          ></plan-template>
        </div>
      </div>
    </div>
    <v-snackbar :color="bgColor" :timeout="timeOut" top v-model="snackbar">
      <div style="text-align: center; width: 100%">
        <span style="padding-right:1.0rem"
          ><v-icon color="#fff">{{ snackIcon }}</v-icon></span
        >{{ snackMessage }}
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import AddPlanForm from "./add-plan-form";
import PlanTemplate from "../../global-components/plan-template";
import {
  GET_SUBSCRIPTION_PLANS,
  ADD_PLAN,
  GET_FEATURES,
  UPDATE_PLAN
} from "../../../Api/admin_api";
export default {
  name: "manage-plans",
  components: {
    AddPlanForm,
    PlanTemplate
  },
  data: function() {
    return {
      title: null,
      plans: [],
      features: [],
      addNew: false,
      openForm: false,
      editablePlan: {},
      noPlan: false,
      newKey: 0,
      newPlan: null,
      plan_type: 1,
      plan_status: 1,
      published: false,
      bgColor: "#454545",
      timeOut: 2000,
      snackbar: false,
      snackIcon: "",
      snackMessage: "",
      ripple: false
    };
  },
  methods: {
    resetAll() {
      this.newPlan = null;
      this.newKey++;
    },
    goToDashboard() {
      this.$router.push({ name: "adminDashboard" }).catch(function() {});
    },
    closeForm() {
      const self = this;
      self.openForm = false;
      self.editablePlan = null;
    },
    editPlan(plan) {
      const self = this;
      self.editablePlan = plan;
      self.openForm = true;
    },
    addPlan(plan) {
      const self = this;
      ADD_PLAN(plan)
        .then(function(response) {
          self.openForm = false;
          self.resetAll();
          self.snackbar = true;
          self.snackIcon = self.$constants.SNACKBAR_ICON.SUCCESS;
          self.bgColor = self.$constants.SNACKBAR_COLOR.SUCCESS;
          self.snackMessage = response.message;
        })
        .catch(function(response) {
          self.snackbar = true;
          self.snackIcon = self.$constants.SNACKBAR_ICON.ERROR;
          self.bgColor = self.$constants.SNACKBAR_COLOR.ERROR;
          self.snackMessage = response.message;
        });
    },
    updatePlan(plan) {
      const self = this;
      UPDATE_PLAN(plan)
        .then(function(response) {
          self.openForm = false;
          self.snackbar = true;
          self.snackIcon = self.$constants.SNACKBAR_ICON.SUCCESS;
          self.bgColor = self.$constants.SNACKBAR_COLOR.SUCCESS;
          self.snackMessage = response.message;
          self.getPlans(self.plan_type, self.plan_status);
        })
        .catch(function(response) {
          self.snackbar = true;
          self.snackIcon = self.$constants.SNACKBAR_ICON.ERROR;
          self.bgColor = self.$constants.SNACKBAR_COLOR.ERROR;
          self.snackMessage = response.message;
        });
    },
    getPlans(type, status) {
      const self = this;
      self.plans = [];
      GET_SUBSCRIPTION_PLANS(type, status)
        .then(function(response) {
          self.features = response.data.features;
          if (response.data.plans.length > 0) {
            self.plans = response.data.plans;
            self.plans.sort((a, b) =>
              parseInt(a.price) > parseInt(b.price) ? 1 : -1
            );
          } else {
            self.noPlan = true;
          }
        })
        .catch(function() {});
    },
    getFeatures() {
      const self = this;
      self.features = [];
      GET_FEATURES()
        .then(function(response) {
          self.features = response.data.features;
          self.newKey++;
        })
        .catch(function() {});
    }
  },
  watch: {
    "$route.query.q"(newQ, oldQ) {
      if (newQ !== oldQ) {
        if (newQ === "published") {
          this.getPlans(1, 2);
          this.title = "Published Plans";
          this.addNew = false;
          this.newPlan = false;
          this.plan_type = 1;
          this.plan_status = 2;
          this.published = true;
        } else if (newQ === "saved") {
          this.getPlans(1, 1);
          this.title = "Saved Plans";
          this.addNew = false;
          this.newPlan = true;
          this.plan_type = 1;
          this.plan_status = 1;
          this.published = false;
        } else {
          this.title = "New Plan";
          this.addNew = true;
          this.openForm = false;
          this.editablePlan = null;
          this.newPlan = true;
          this.newKey++;
          this.getFeatures();
        }
      }
    }
  },
  mounted() {
    if (this.$route.query.q === "published") {
      this.title = "Published Plans";
      this.newPlan = false;
      this.openForm = false;
      this.plan_type = 1;
      this.plan_status = 2;
      this.published = true;
      this.getPlans(1, 2);
    } else if (this.$route.query.q === "saved") {
      this.title = "Saved Plans";
      this.newPlan = true;
      this.openForm = false;
      this.plan_type = 1;
      this.plan_status = 1;
      this.published = false;
      this.getPlans(1, 1);
    } else {
      this.getFeatures();
      this.title = "New Plan";
      this.addNew = true;
      this.newPlan = true;
      this.openForm = false;
      this.editablePlan = null;
    }
  }
};
</script>

<style scoped>
.manage {
  height: 80vh;
  overflow-y: auto;
}
.manage-ttl {
  font-size: 2rem;
  text-align: left;
  margin-left: 2rem;
}
.plan-content-wrapper {
  margin-top: 2rem !important;
}
.plan-wrapper {
  background-color: #ffffff;
  border-radius: 0.8rem;
  box-shadow: 0 0.8rem 1.6rem 0 rgba(0, 0, 0, 0.16);
  max-width: 35rem;
  height: 100%;
}
.h-ttl {
  padding: 1rem 0;
  height: 9.2rem;
}
.p1 {
  background-image: url("../../../assets/newDesign/top-maks.png");
}
.p2 {
  background-image: url("../../../assets/newDesign/top-maks-2.png");
}
.p3 {
  background-image: url("../../../assets/newDesign/top-maks-3.png");
}
.ttl {
  margin-top: 2rem;
  font-size: 2rem;
  font-weight: bold;
  line-height: 1.25;
  text-align: center;
  color: #121212;
}
.price {
  line-height: 1.25;
  margin-top: 1rem;
}
.prc-text {
  color: #34334a;
  font-size: 6.4rem;
  line-height: 1.25;
  letter-spacing: -0.16rem;
  font-weight: bold;
}
.features {
  padding: 2rem;
  text-align: left;
}
.feature {
  margin: 0.8rem 0;
}
.c-ico {
  color: var(--button-color);
  margin-right: 0.5rem;
}
.edit {
  padding: 2rem;
}
.add-plan {
  cursor: pointer;
  height: inherit;
}
.noPlan {
  height: 44rem;
}
.published-plan {
  /*margin-top: 3rem;*/
}
.published-plan-text {
  font-size: 2.4rem;
  text-align: left;
  font-weight: bold;
  margin-left: 2rem;
}
.saved-plan {
  margin-top: 3rem;
}
.saved-plan-text {
  font-size: 2.4rem;
  text-align: left;
  font-weight: bold;
  margin-left: 2rem;
}
</style>
